
const RESUME_API_URL =
  "https://orbiee-backend-dev-218142584790.us-central1.run.app/api/sessions/resume";

export const resumeSession = async (userId) => {
  if (!userId) {
    throw new Error("userId is required");
  }
  const headers = {
    Accept: "application/json",
    "X-User-Id": String(userId),
  };
  const response = await fetch(RESUME_API_URL, {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    throw new Error(
      `Failed to resume session: ${response.status}`
    );
  }

  return response.json();
};
